import { brandsSlider } from './brands-slider'
import { header } from './header'
import { hero } from './hero'

export { brandsSlider, header, hero }
